import React, { ReactNode } from 'react';
import { Button, Popover } from 'antd';
import { CopyOutlined, ExclamationCircleOutlined } from '@ant-design/icons';
import { Catcher, LightSearch } from '../index';
import cx from 'classnames';
import { NotificationType } from '../../interfaces';
import { addNotification } from '../../middleware';
import { tB, tNM } from '../../translate';
import Styles from '../styles/m_itemCardStyles.less';

type ITransactionContent = {
    isLight?: boolean;
    transactionInfo?: any;
    className?: string;
};

type IShowTransactionErrorInfo = ITransactionContent & {
    isError?: boolean;
    className?: never;
};

const transactionErrorContent = (transactionContent: ITransactionContent): ReactNode => {
    const data = JSON.stringify(transactionContent.transactionInfo, null, `\t`);
    return (
        <div className={transactionContent.className}>
            {data.split(`\n`).map((str, ind) => (
                <p key={ind}>{transactionContent.isLight ? <LightSearch text={str} /> : str}</p>
            ))}
        </div>
    );
};

export const ShowRawDataInfo: React.FC<IShowTransactionErrorInfo> = ({
    isError,
    isLight,
    transactionInfo,
}: IShowTransactionErrorInfo) => {
    if (!transactionInfo) {
        return null;
    }

    const onClickTransactionError = (): void => {
        navigator.clipboard.writeText(JSON.stringify(transactionInfo)).then(() => {
            addNotification({
                type: isError ? NotificationType.ERROR : NotificationType.INFO,
                message: isError
                    ? 'The error is copied to the exchange buffer.'
                    : 'The data is copied to the exchange buffer.',
            });
        });
    };
    const transactionErrorPopoverTitle = (): ReactNode => {
        return (
            <div className={Styles.transactionErrorPopoverTitle}>
                <div className={cx(Styles.title, isError ? Styles.errorTitle : Styles.okTitle)}>
                    {tNM(isError ? 'Error!' : 'Data')}
                </div>
                <Button
                    className={Styles.button}
                    onClick={onClickTransactionError}
                    size={'small'}
                    type={'primary'}
                    icon={<CopyOutlined />}
                >
                    {tB('Copy Clipboard')}
                </Button>
            </div>
        );
    };

    return (
        <Catcher>
            <Popover
                placement="top"
                title={transactionErrorPopoverTitle}
                content={transactionErrorContent({
                    transactionInfo,
                    isLight,
                    className: Styles.transactionErrorPopoverContent,
                })}
                trigger="hover"
            >
                <ExclamationCircleOutlined onClick={onClickTransactionError} className={Styles.errorIcon} />
            </Popover>
        </Catcher>
    );
};

export const divShowRawDataInfo = (errors: any) => {
    return (
        <div>
            {tNM('Error!')} <ShowRawDataInfo transactionInfo={errors} isError />
            {transactionErrorContent({
                transactionInfo: errors,
                className: Styles.transactionErrorNotificationContent,
            })}
        </div>
    );
};
